// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"67272ea9","466":"faf23e06","738":"c5c60c21","787":"2550c810","856":"56ed2c19","858":"3c7894c8"}[chunkId] + ".chunk.js";
};